/**
 * React
 */
import React, { useMemo, useCallback } from 'react';

/**
 * Library
 */
import clsx from 'clsx';

/**
 * MUI
 */
import { IconButton, Tooltip } from '@material-ui/core';

/**
 * Hooks
 */
import { useLibrary } from 'hooks';

/**
 * Components
 */
import { LibraryProps } from 'components/Library/type';

/**
 * styles
 */
import { useStyles } from 'components/Library/styles';

/**
 * Constants
 */
import { AvailableDownloadStatus } from 'commons/constants/KeyFlowConstants';

/**
 * Image
 */
import { DownloadIcon } from 'asset/images';

/**
 *
 * Default function
 */
function Library({ library }: LibraryProps) {
  const classes = useStyles();
  const { onDownloadLibrary, onDownloadLibraryCloudfront } = useLibrary();

  const {
    libraryStatus,
    inTimecode,
    outTimecode,
    durationTimecode,
    workingTime,
    backgroundImageURL,
  } = useMemo(() => {
    const { inTimecode, outTimecode, durationTimecode, workingTime } = library;

    return {
      libraryStatus: library.getLibraryStatusText(),
      inTimecode,
      outTimecode,
      durationTimecode,
      workingTime,
      backgroundImageURL: library.getThumbnailBackgroundURL(),
      // backgroundImageURL: `url(${HostFactory.cloudfrontURL}/THUMBNAIL/201028000011/201030000001/V201030000001_ea466f13-71eb-4012-9860-93db8f6a9f6a.0000000.jpg), url(${ThumbnailDefault})`,
    };
  }, [library]);

  const isDownload = useMemo(() => {
    const { isAvailableDownload } = library;
    return isAvailableDownload === AvailableDownloadStatus.DOWNLOADABLE;
  }, [library.isAvailableDownload]);

  const onDownload = useCallback(() => {
    const { filePath, videoId, id, categoryId, assetTitle, contents } = library;

    // onDownloadLibrary({ id, assetId });
    const gameDate = '20' + categoryId.toString().slice(0, 6);
    onDownloadLibraryCloudfront(filePath, videoId, id, `${library.resolution === 'PROXY' ? '[클린본] ' : ''}${gameDate}_${assetTitle}_${contents}.mp4`);
  }, [library]);

  return (
    <div className={clsx(classes.container, classes.tableRow)}>
      <div className={clsx(classes.tableColumn, classes.thumbnailColumn)}>
        <span
          className={classes.thumbnail}
          style={{
            backgroundImage: backgroundImageURL,
          }}
        />
      </div>
      <div className={classes.mobileContainer}>
        <div className={clsx(classes.tableColumn, classes.contentsColumn, classes.contents)}>
          <div>
            <Tooltip title="애셋 제목">
              <p className={clsx(classes.colorGray, classes.assetTitle, classes.ellipsis)}>
                {library.assetTitle}
              </p>
            </Tooltip>
            <Tooltip title="부분인출 제목">
              <p className={clsx(classes.contentsTitle, classes.ellipsis)}>{library.contents}</p>
            </Tooltip>
            {/* <p className={clsx(classes.contentsTitle, classes.ellipsis)}>{library.id}</p> */}
          </div>
        </div>
        <div className={clsx(classes.tableColumn, classes.fileColumn, classes.colorBlack)}>
          <span>
            <p>{library.resolution === 'PROXY' && '[클린본]'}</p>
            <Tooltip title="요청 구간">
              <p>
                {inTimecode} ~ {outTimecode}
              </p>
            </Tooltip>
            <Tooltip title="요청 길이">
              <p>{durationTimecode}</p>
            </Tooltip>
          </span>
        </div>
        <div className={clsx(classes.tableColumn, classes.dateOfReqeustColumn, classes.colorBlack)}>
          <span>
            <p>{library.formattedDateOfCreated}</p>
          </span>
        </div>
        <div className={clsx(classes.tableColumn, classes.dateOfTaskColumn)}>
          <span>
            <p>{workingTime}</p>
          </span>
        </div>
        <div className={clsx(classes.tableColumn, classes.statusColumn)}>
          <span>
            <p>{libraryStatus}</p>
          </span>
        </div>
      </div>
      <div className={clsx(classes.tableColumn, classes.downloadColumn)}>
        <span className={clsx(!isDownload && classes.notDownload)}>
          {/* <IconButton disabled={!isDownload} href={downloadURL} download> */}
          <IconButton disabled={!isDownload} onClick={onDownload}>
            <img src={DownloadIcon} />
          </IconButton>
        </span>
      </div>
    </div>
  );
}

export default Library;
